import { useEffect, useRef } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useIntersectionObserver } from '@/components/hooks/useIntersectionObserver'
import { usePageTracker } from 'libs/searchspring/hooks/usePageTracker'

export function InfiniteScrollNext() {
  const { results, refine, isLoading } = useSearchspringContext()
  const { loadedPages } = usePageTracker()
  const totalPages = results?.pagination?.totalPages ?? 1
  const { setNode, entry } = useIntersectionObserver({
    rootMargin: '300px',
    threshold: 0.1
  })

  useEffect(() => {
    if (isLoading) return
    if (entry?.isIntersecting) {
      handleNextPage()
    }
  }, [entry])

  const handleNextPage = () => {
    const nextPage = loadedPages[loadedPages.length - 1] + 1
    if (nextPage > totalPages) return
    refine('page', nextPage)
  }

  // Hide load more if all pages are loaded
  if (loadedPages[loadedPages.length - 1] >= totalPages) return null
  return (
    <div className="col-span-full flex items-center justify-center px-margin pt-2 pb-0">
      <button ref={setNode} className="btn btn-primary btn-fill btn-m btn-bold" onClick={handleNextPage} aria-label="Load More">
        Load More
      </button>
    </div>
  )
}

export function InfiniteScrollPrevious() {
  const { refine, isLoading } = useSearchspringContext()
  const { loadedPages } = usePageTracker()
  const hasBeenClicked = useRef(false)
  const { setNode, entry } = useIntersectionObserver({
    rootMargin: '100px',
    threshold: 1
  })

  useEffect(() => {
    if (!hasBeenClicked.current) return
    if (isLoading) return
    if (entry?.isIntersecting) {
      handlePrevPage()
    }
  }, [entry])

  const handleClick = () => {
    hasBeenClicked.current = true
    handlePrevPage()
  }

  // Handle previous page based on array of loaded pages
  const handlePrevPage = () => loadedPages.length && loadedPages[0] !== 1 && refine('page', loadedPages[0] - 1)

  // Hide load previous if first page is loaded
  if (!loadedPages.length || loadedPages[0] === 1) return null
  return (
    <div className="col-span-full flex items-center justify-center px-margin py-2">
      <button ref={setNode} className="btn btn-primary btn-fill btn-m btn-bold" onClick={handleClick} aria-label="Load Previous">
        Load Previous
      </button>
    </div>
  )
}
